import styled from 'styled-components'

export const TopBarStyledContainer = styled.g<{ dashTheme: string }>`
    &,
    * {
        transition: none !important;
    }

    /* .topEvent {
        fill: #000 !important;
    } */
`

export const TopEventText = styled.tspan`
    fill: #000 !important;
`

export const TextContainer = styled.p`
    display: -webkit-box;
    line-height: 18px;
    font-size: 18px;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: ${({ theme }) => theme['font-regular']};
    text-align: center;
    font-weight: 600;
    color: ${({ theme }) => theme['gray-900']};
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
`
